import React, { Component } from 'react'
import Home from './pages/Home'
import Navbar from './pages/navbar'
import './style.css'
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import { Navigate, Route, Routes } from 'react-router-dom'
import Register from './pages/register'
import LogIn from './pages/login'
import ShoppingCart from './pages/shoppingcart'
import axios from 'axios'
import Address from './pages/address'
import Pay from './pages/pay'
import AOS from 'aos';
import 'aos/dist/aos.css'; 
AOS.init();

export default class App extends Component {
    state = {
        products :[
              {
                id: 1,
                imgUrl: "https://images.restocks.net/products/AO4606-700/nike-air-force-1-low-off-white-volt-3-1000.png",
                name: "Best waterproof shoe for hiking",
                likes: " 9 likes",
                price: 360,
                isInCart: false ,
                count : 1 ,
                fade : "fade-down"
              },
              {
                id: 2,
                imgUrl: "https://www.pngplay.com/wp-content/uploads/12/Running-Shoes-PNG-Clip-Art-HD-Quality.png",
                name: "Best Nike shoe for men",
                likes: " 13 likes",
                price: 234,
                isInCart: false ,
                count : 1 ,
                fade : "fade-up"
              },
              {
                id: 3,
                imgUrl: "https://www.pngall.com/wp-content/uploads/2016/06/Adidas-Shoes-Free-Download-PNG.png",
                name: "Zpunet company shoe",
                likes: " 11 likes",
                price: 160,
                isInCart: false ,
                count : 1 ,
                fade : "fade-down"
              },
              {
                id: 4,
                imgUrl: "https://www.pngkit.com/png/full/361-3611117_brown-shoes-png-download-image-woodland-semi-formal.png",
                name: "Nice boot from alibaba",
                likes: " 5 likes",
                price: 100,
                isInCart: false ,
                count : 1 ,
                fade : "fade-up"
              },
              {
                id: 5,
                imgUrl: "https://www.freepnglogos.com/uploads/shoes-png/dance-shoes-png-transparent-dance-shoes-images-5.png",
                name: "New star from adidas",
                likes: " 15 likes",
                price: 340,
                isInCart: false ,
                count : 1 ,
                fade : "fade-down"
              },
              {
                id: 6,
                imgUrl: "https://res.cloudinary.com/zpune/image/upload/v1644396419/random/10_kglqts.png",
                name: "Female Pink Shoes",
                likes: " 7 likes",
                price: 430,
                isInCart: false ,
                count : 1 ,
                fade : "fade-up"
              },
              {
                id: 7,
                imgUrl: "https://png.pngitem.com/pimgs/s/488-4882835_black-plush-heels-png-clipart-black-high-heels.png",
                name: "Women Black high Heels",
                likes: " 20 likes",
                price: 228,
                isInCart: false ,
                count : 1 ,
                fade : "fade-down"
              },
              {
                id: 8,
                imgUrl: "https://freepngimg.com/thumb/shoes/54161-6-booties-image-download-hq-png-thumb.png",
                name: "Low heel brown boot",
                likes: " 4 likes",
                price: 149,
                isInCart: false ,
                count : 1 ,
                fade : "fade-up"
              },
              {
                id: 9,
                imgUrl: "https://freepngimg.com/thumb/shoes/54205-2-booties-free-hq-image-thumb.png",
                name: "Female high heel",
                likes: " 20 likes",
                price: 929,
                isInCart: false ,
                count : 1 ,
                fade : "fade-down"
              },
              {
                id: 10,
                imgUrl: "https://freepngimg.com/thumb/shoes/3-2-shoes-transparent-thumb.png",
                name: "Velcro Sneakers For Boys & Girls (Blue)",
                likes: " 32 likes",
                price: 599,
                isInCart: false ,
                count : 1 ,
                fade : "fade-up"
              },
              {
                id: 11,
                imgUrl: "https://freepngimg.com/thumb/shoes/28172-8-nike-shoes-image.png",
                name: "Sports Nike Shoes",
                likes: " 32 likes",
                price: 420,
                isInCart: false ,
                count : 1 ,
                fade : "fade-down"
              },
              {
                id: 12,
                imgUrl: "https://freepngimg.com/thumb/shoes/27399-2-female-shoes-hd.png",
                name: "Female Red high heel",
                likes: " 32 likes",
                price: 600,
                isInCart: false ,
                count : 1 ,
                fade : "fade-up"
              },
              {
                id: 13,
                imgUrl: "https://freepngimg.com/thumb/shoes/21932-9-red-high-heel-shoes.png",
                name: "Female Red high heels",
                likes: " 32 likes",
                price: 1200,
                isInCart: false ,
                count : 1 ,
                fade : "fade-down"
              },
              {
                id: 14,
                imgUrl: "https://freepngimg.com/thumb/shoes/28530-3-nike-shoes-transparent-thumb.png",
                name: "Sport Nike Shoes",
                likes: " 32 likes",
                price: 700,
                isInCart: false ,
                count : 1 ,
                fade : "fade-up"
              },
              {
                id: 15,
                imgUrl: "https://freepngimg.com/thumb/shoes/27736-7-female-shoes-image-thumb.png",
                name: "Female pink high heels",
                likes: " 32 likes",
                price: 2400,
                isInCart: false ,
                count : 1 ,
                fade : "fade-down"
              },
              {
                id: 16,
                imgUrl: "https://freepngimg.com/thumb/shoes/55508-7-sneakers-download-image-download-free-image-thumb.png",
                name: "Female Sneakers",
                likes: " 32 likes",
                price: 900,
                isInCart: false ,
                count : 1 ,
                fade : "fade-up"
              },
              {
                id: 17,
                imgUrl: "https://freepngimg.com/thumb/shoes/54203-6-booties-picture-hd-image-free-png-thumb.png",
                name: "Female Black low heel",
                likes: " 32 likes",
                price: 1700,
                isInCart: false ,
                count : 1 ,
                fade : "fade-down"
              },
              {
                id: 18,
                imgUrl: "https://freepngimg.com/thumb/shoes/54167-8-booties-free-photo-png-thumb.png",
                name: "Female Brown high heel",
                likes: " 32 likes",
                price: 3200,
                isInCart: false ,
                count : 1 ,
                fade : "fade-up"
              },
              {
                id: 19,
                imgUrl: "https://freepngimg.com/thumb/shoes/54211-5-booties-free-hq-image-thumb.png",
                name: "Female Black high heel",
                likes: " 32 likes",
                price: 3100,
                isInCart: false ,
                count : 1 ,
                fade : "fade-down"
              },
              {
                id: 20,
                imgUrl: "https://freepngimg.com/thumb/shoes/54153-7-booties-download-hq-png-thumb.png",
                name: "Female Grey Boot",
                likes: " 32 likes",
                price: 1900,
                isInCart: false ,
                count : 1 ,
                fade : "fade-up"
              }
            ]
           , 
        info :{  
            name: " ",
            email : " " ,
            Governorate: " ",
            city: " ",
            code: " ",
            country: " "
        },
        totalPrice : 0 ,
        shipping :40 , 
        tax : 70 , 
        price : 0 
    }

    handleChange = e => {
        const info =  {...this.state.info}

        info[e.currentTarget.name] = e.currentTarget.value

        this.setState({info})
        // console.log(info)
    }
    async componentDidMount(){
        const { data } = await axios.get("http://localhost:3000/products")
        this.setState({
            products : data
        })
    }
    handleClone = async c =>{
        const buyProducts = [...this.state.products]
        const index = buyProducts.indexOf(c)

        buyProducts[index].isInCart = !buyProducts[index].isInCart
        this.setState({
            products : buyProducts
        })
        this.handleTotal()
    }
    handleDelete = d =>{
        const products = [...this.state.products.filter( f => f.id !== d.id)]
        this.setState({products})
    }
    handleAdd = a => {
        const products = [...this.state.products]
        const index = products.indexOf(a)
        products[index].count++
        this.setState({products})
    }
    handleTotal = () => {
        const p = [...this.state.products.filter(f => f.isInCart === true)]
        const total = []
        p.map(s => {
            return total.push(s.price * s.count)
        })
        const all = total.reduce((acc , current ) => {
            return  acc + current + 0
        })
        this.setState({ totalPrice : all })
    }
    render() {
        return (
            <React.Fragment>
                <Navbar products={this.state.products} onSearch={this.handleSearch} search={this.state.search}/>
                <Routes >
                    <Route path='/' element={<Home products={this.state.products} onTotal={this.handleTotal} onClone={this.handleClone} onDelete={this.handleDelete} onAdd={this.handleAdd}/>} />
                    <Route path='/register' element={<Register />} />
                    <Route path='/login' element={<LogIn />} />
                    <Route path = '/home' element ={<Navigate to='/'/>} />
                    <Route path='/shoppingcart' element={<ShoppingCart products={this.state.products} onTotal={this.handleTotal} onClone={this.handleClone} onDelete={this.handleDelete} onAdd={this.handleAdd}/>} />
                    <Route path='/address/' element = {<Address info = {this.state.info} onChange={this.handleChange}/>} />
                    <Route path='/pay/' element={<Pay info={this.state.info} totalPrice = {this.state.totalPrice} products = {this.state.products} tax ={this.state.tax} shipping = {this.state.shipping} price= {this.state.price}/>} />
                </Routes>
            </React.Fragment>
        )
    }
}
